import validator from 'validator';
import { isEmpty } from '../isEmpty';

export const validateClassFormFields = (data, isEdit) => {
    let errors = {};
    let fields = { ...data };

    fields.name = !isEmpty(data.name) ? data.name : '';
    fields.image = data.image !== null ? data.image : '';
    fields.description = !isEmpty(data.description) ? data.description : '';
    fields.startDate = !isEmpty(data.startDate) ? data.startDate : '';
    fields.startTime = !isEmpty(data.startTime) ? data.startTime : '';
    fields.endTime = !isEmpty(data.endTime) ? data.endTime : '';
    fields.capacity = !isEmpty(data.capacity) ? data.capacity : '';
    fields.price = !isEmpty(data.price) ? data.price : '';

    if (validator.isEmpty(fields.name)) {
        errors.name = 'Name is required';
    }

    if (!isEdit && (fields.image === '' || !fields.image)) {
        errors.image = 'Image is required';
    }

    if (validator.isEmpty(fields.description)) {
        errors.description = 'Description is required';
    }

    if (validator.isEmpty(fields.startDate)) {
        errors.startDate = 'Start date is required';
    }

    if (validator.isEmpty(fields.startTime)) {
        errors.startTime = 'Required';
    }

    if (validator.isEmpty(fields.endTime)) {
        errors.endTime = 'Required';
    }

    if (validator.isEmpty(String(fields.capacity))) {
        errors.capacity = 'Required';
    }

    if (validator.isEmpty(String(fields.price))) {
        errors.price = 'Required';
    }

    return {
        errors,
        fields,
        isValid: isEmpty(errors),
    };
};



// WEBPACK FOOTER //
// ./src/Validation/CreateClassValidation/index.js